import type {InjectionKey, Ref} from 'vue'
import OperatorApplicationType from "~/cabinet/ts/data/online/config/OperatorApplicationType";
import {
    EditAutoActionPayloadInterface
} from "~/cabinet/vue/client/online/config/autoActions/useOnlineChatAutoActionConfig";
import Dictionary from "~/ts/library/Dictionary";

export const OnlineChatOperatorApplicationsProvide = Symbol("OnlineChatOperatorApplicationsProvide") as InjectionKey<Ref<OperatorApplicationType[]>>;
export const OnlineChatSiteIsFreeProvide = Symbol("OnlineChatSiteIsFreeProvide") as InjectionKey<Ref<boolean>>;
export const OnlineChatSitePackagesProvide = Symbol("OnlineChatSitePackageIdsProvide") as InjectionKey<Ref<Dictionary<SitePackageInterface>>>;
export const OnlineChatSiteIdProvide = Symbol("OnlineChatSiteIdProvide") as InjectionKey<Ref<string>>;
export const OnlineChatEditAutoActionProvide = Symbol("OnlineChatEditAutoActionProvide") as InjectionKey<(payload: EditAutoActionPayloadInterface) => void>

export interface SitePackageInterface {
    id: string;
    descr: string;
    isEnabled: boolean;
}

export const ChatBotPackageId = "chatBot";
export const WebRtcPackageId = "webRtc";
export const AiPackageId = "ai";
export const KnowledgeBasePackageId = "knowledgeBase";